<template>
  <div id="conseils-content">
    <h1 class="display-2 my-5 pt-5 text-xs-center">
      {{ title }}
    </h1>

    <section id="intro">

      <v-img
        :srcset="require('../assets/woman-writing-cv.webp')"
        :src="require('../assets/woman-writing-cv.jpg')"
        :alt="altimg"
        max-height="500px"
        contain
      >
      </v-img>

      <p class="thetext subheading mt-5 mb-4">
        {{ intro }}
      </p>

    </section>

    <section id="cv-target">
      <h2 class="display-1 mt-5">{{ sectTargetTitle }}</h2>
      <h3 class="headline mt-3">{{ sectTargetSubTitle1 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ sectTargetPart1_1 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ sectTargetPart1_2 }}
      </p>

      <h3 class="headline mt-3">{{ sectTargetSubTitle2 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ sectTargetPart2_1 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ sectTargetPart2_2 }}
      </p>
    </section>

    <section id="cv-expedu">
      <h2 class="display-1 mt-5">{{ expEduTitle }}</h2>

      <h3 class="headline mt-3">{{ expEduSubTitle1 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ expEduContent1_1 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ expEduContent1_2 }}
      </p>

      <h3 class="headline mt-3">{{ expEduSubTitle2 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ expEduContent2 }}
      </p>

      <h3 class="headline mt-3">{{ expEduSubTitle3 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ expEduContent3 }}
      </p>
    </section>

    <section id="cv-formcv">
      <h2 class="display-1 mt-5">{{ formCvTitle }}</h2>

      <h3 class="headline mt-3">{{ formCvSubtitle1 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ formCvContent1 }}
      </p>

      <h3 class="headline mt-3">{{ formCvSubtitle2 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ formCvContent2 }}
      </p>

      <h3 class="headline mt-3">{{ formCvSubtitle3 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ formCvContent3_1 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ formCvContent3_2 }}
      </p>

      <h3 class="headline mt-3">{{ formCvSubtitle4 }}</h3>
      <p class="thetext subheading mt-2 mb-4">
        {{ formCvContent4 }}
      </p>

    </section>

    <section id="cv-liar">
      <h2 class="display-1 mt-5">{{ hobbiesTitle }}</h2>
      <p class="thetext subheading mt-2 mb-4">
        {{ hobbiesContent }}
      </p>
    </section>

    <section id="cv-target">
      <h2 class="display-1 mt-5">{{ liarTitle }}</h2>
      <p class="thetext subheading mt-2 mb-4">
        {{ liarContent1 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ liarContent2 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ liarContent3 }}
      </p>
      <p class="thetext subheading mt-2 mb-4">
        {{ liarContent4 }}
      </p>
    </section>

  </div>

</template>

<script>
 export default {
   data() {
     return {
       altimg: "curriculum vitae conseils fuzzcv",
       title: "Nos conseils pour réaliser un Curriculum Vitae efficace",
       intro: `Votre Curriculum Vitae est le premier pas vers votre nouvel emploi.
Bien que les recruteurs ne passent que quelques minutes par CV, il est un élément crucial de sélection des candidats.
Votre curriculum vitae doit être soigné et répondre à des codes afin d'attirer l'attention des recruteurs et de vous démarquer.
FuzzCV vous offre une interface souple et fonctionnelle afin de rédiger le contenu de votre CV et des modèles de CV pertinents et efficaces pour la mise en forme.`,
       sectTargetTitle: `Ajuster le Curriculum Vitae au poste ciblé`,
       sectTargetSubTitle1: `Ciblez votre CV`,
       sectTargetPart1_1: `Votre candidature doit apparaître comme la réponse à l'offre d'emploi publiée par un employeur.
Si vous répondez à une offre précise, orientez votre CV pour que votre profil mette en avant que vous avez toutes les compétences et l'expérience pour exercer ce poste.
Par exemple, reprenez le titre de l'annonce et faite en le titre de votre CV. Pour le même poste, les entreprises utilisent différents titres.
En reprenant les termes du titre utilisé pour le poste proposé, vous apparaîtrez plus proche de l'esprit de cette entreprise; ou, tout du moins, ceci indiquera à votre lecteur que vous avez pris la peine de modifier votre CV pour candidater à ce poste précis.`,
       sectTargetPart1_2:`Le descriptif de l'offre d'emploi à laquelle vous répondez spécifiera probablement des compétences techniques ou de savoir être et des expériences souhaitées.
Si vous avez ces compétences et ces expériences, mettez les en valeur en reprenant les mots clés de l'annonce et incluez les dans votre CV.`,
       sectTargetSubTitle2: `Réajustez et faites évoluer votre Curriculum Vitae`,
       sectTargetPart2_1: `Lors de vos entretiens d'embauches, les questions de vos interlocuteurs pourrons mettre en évidence qu'ils ont mal interpréter certains aspects de votre CV.
Réajuster celui-ci afin d'éviter les ambiguïtés.
Il se peut aussi que certaines compétences chères à l'employeur ne sont pas suffisamment apparue dans votre CV.
Si vous détenez ces éléments recherchés : mettez les plus en évidence!`,
       sectTargetPart2_2: `Un curriculum vitae se raffine, s'adapte, évolue et se perfectionne au fur et à mesure.`,
       expEduTitle: `les expériences professionnelles et les formations`,
       expEduSubTitle1: `Les expériences professionelles et formations les plus récentes d'abord!`,
       expEduContent1_1: `Tout d'abord, celles-ci se présentes de façon anti-chronologique : c'est à dire que les dernières expériences professionnelles et formations apparaissent en premier dans l'ordre chronologique.
En effet, ce sont les dernières expériences et compétences acquises qui intéresseront le plus un recruteur.`,
       expEduContent1_2: `FuzzCV vous permet de facilement décrire de façon structurée vos expériences professionnelles et les formations que vous avez suivies.`,
       expEduSubTitle2: `Comment décrire ses expériences professionnelles et formations`,
       expEduContent2:`Si vous avez beaucoup d'expériences et avez exercé de nombreux postes, inutile de détailler les postes les plus anciens : si vous avez 20 ans d'expériences, les détails de votre premier stage apportera peu! Votre CV devant être court, gardez cet espace précieux afin de mieux détailler vos dernières expériences.
Vous pouvez, par exemple, regrouper plusieurs emplois dans une seule entrée "expérience professionnelles" en spécifiant vos différents employeurs et dates d'activité dans la description de l'expérience.`,
       expEduSubTitle3: `Expérimenté ou débutant`,
       expEduContent3: `L'interface de FuzzCV vous permet d'aérer votre CV en insérant précisément des espaces entre les sections principales mais aussi entre chaque éléments d'une section (ex : entre deux expériences professionnelles ou deux formations). Ainsi, si vous débutez et avez peu d'expérience, vous pouvez répartir vos informations sur la page. Au contraire, si vous avez beaucoup d'expériences et qu'une seule page ne vous suffit pas, vous pouvez organisez votre CV afin que le passage à la seconde page soit fluide.`,
       formCvTitle: `La forme de votre Curriculim Vitae : structure et mise en page`,
       formCvSubtitle1: `FuzzCV vous propose des modèles de CV adaptés`,
       formCvContent1: `En ce qui concerne la mise en page, FuzzCV vous propose des modèles de CV efficaces et pertinents. Nos CV sont optimisés pour l'impression : le dosage des couleurs est ajustés afin d'éviter la sur-consommation d'encre ou de faire baver votre document en imbibant celui-ci d'encre.
Nos modèles vont du style le plus classique au plus moderne. Tester les et faites votre choix!`,
       formCvSubtitle2: `Renseignez vos informations, FuzzCV s'occupe de la mise en page!`,
       formCvContent2: `Les sections "expériences professionnelles" et "éducation" vous permettent d'inscrire et de mettre en valeur les informations incontournables : Titre du poste, dates de début et de fin, localisation du lieu de travail ou de l'établissement d'enseignement. Pour chacun de ces éléments, une zone de saisie libre vous permet de détailler l'activité ou la formation effectuée.
Aucun éléments n'est obligatoire. Lors de l'édition du formulaire, vous ne renseignez que les parties qui vous semblent pertinentes.`,
       formCvSubtitle3: `Attention aux fautes d'orthographe!`,
       formCvContent3_1: `Évidemment, on ne peut que vous conseiller d'être attentif aux coquilles et fautes d'orthographes. Les fautes d'orthographes, de grammaire ou de syntaxe peuvent être éliminatoires pour un recruteur : faites vous relire!`,
       formCvContent3_2: `Nous vous conseillons d'utiliser des phrase courtes, synthétiques et percutantes. N'hésitez pas à utiliser le jargon propre à votre secteur d'activité. Vous n'en apparaîtrez que plus professionnel.`,
       formCvSubtitle4: `FuzzCV génère un Curriculum Vitae au format PDF`,
       formCvContent4:`Lors de la génération de votre Curriculum Vitae au format PDF, celui-ci porte le nom que vous avez donné à votre CV. Si vous faites parvenir ce document par mail à votre correspondant, nous vous conseillons de le renommer ainsi : CV_<Nom>_<Prénom>.pdf (ex : CV_Durand_Sandrine.pdf). En évitant les espaces ou des caractères spéciaux dans le nom de votre document, vous le rendez plus facile à enregistrer et ouvrir pour votre interlocuteur.`,
       hobbiesTitle: `Mentionner ses activités extra professionnelles`,
       hobbiesContent: `FuzzCV vous permet de faire apparaître vos hobbies et activités extra professionnelles.
Nous vous conseillons de les mentionner seulement si elles apportent un "plus" à votre CV. Inutile de préciser "Cinéma" ou "lecture".
Par contre, une activité associative mettant en avant des valeurs sera appréciée par l'entreprise. De même que les activités sportives qui dénotent votre dynamisme et votre bonne santé.`,
       liarTitle: `Mentir sur son Curriculum Vitae`,
       liarContent1: `Il est tentant d'enjoliver un curriculum vitae pour mieux se vendre auprès d'un employeur : ajouter un diplôme que l'on a pas obtenu, transformer un stage en CDD, etc...
Ceci peut avoir des conséquences désagréables : au mieux vous ridiculiser lors d'un entretien ou, au pire, mettre fin à votre période d'essai.
Si vous préciser que vous êtes bilingues alors que vous n'avez pas parlé un mot d'anglais depuis le lycée, vous serez très mal à l'aise si le recruteur commence l'entretien en Anglais!`,
       liarContent2: `Afin de vérifier vos dires, les entreprises peuvent effectuer des recherches auprès de vos anciens employeurs et établissements de formation.
Tout simplement, la plupart des employeurs vous demanderons une copie de vos diplômes lors de la signature de votre contrat. Évitez donc des situations embarrassantes!`,
       liarContent3: `Dans l'absolu, soyez honnête sur votre CV et préparez votre entretien pour présenter chaque expérience sous son meilleur jour.`,
       liarContent4: `Si vous avez un profil atypique, soyez transparent et rassurez votre recruteur en mettant en avant la convergence des compétences que vous avez développées.`,

     }
   }

 }
</script>

<style>
 .thetext {
     text-align: justify;
     text-justify: inter-character;
 }
</style>
